/*
 # iOS的滚动修复

 在iOS下，如果整个window下拉到底，那么顶部会出现一块弹性黑色区域，这个体验对WebApp不友好，让人感觉还是一个网页
 这里通过一个hack方式，判断是否滚动到底，如果是，那么往回滚动1px像素，这样就不会触发整个window的滚动了
 */

import utils from "./utils";
import domDelegate from "dom-delegate";

// ！！！！！注意： 该功能开启后
// 只有 .scrollable 和 .scroll 的div内才能触发滚动，务必在你需要滚动的地方加上这两个元素
const SCROLL_CONTAINER_SELECTOR = " .appLayout-body, .scrollable";
const documentDelegate = domDelegate(document);

// eslint-disable-next-line
function handleDocumentTouchMove(evt) {
  evt.preventDefault();
}

// 这里调整scroll是为了在.scroll容器内部支持到滚动底后回弹，但是会有些bug
/* eslint-disable  */
function adjustScrollIfReachEdge(ele) {
  ele.xmCanScrollUp = ele.scrollTop > 0;
  ele.xmCanScrollDown = utils.getScrollBottom(ele) > 0;

  if (!ele.xmCanScrollUp && !ele.xmCanScrollDown) {
    // 既不能往上滚动，也不能往下滚动，说明内容太短，没有滚动条，则不进行任何纠正
    // 因为纠正了也没用
    return;
  }
  if (!ele.xmCanScrollUp) {
    ele.scrollTop = 1;
    ele.xmCanScrollUp = true;
  }
  if (!ele.xmCanScrollDown) {
    ele.scrollTop -= 1;
    ele.xmCanScrollDown = true;
  }
}

/* eslint-enable  */

function getTouchEvent(evt) {
  let touchEvt;
  if (evt.touches && evt.touches[0]) {
    touchEvt = evt.touches[0];
  } else if (
    evt.originalEvent &&
    evt.originalEvent.touches &&
    evt.originalEvent.touches[0]
  ) {
    touchEvt = evt.originalEvent.touches[0];
  }
  return touchEvt;
}

function getScrollElement(evt, ele) {
  if (evt.currentTarget !== document) {
    return evt.currentTarget;
  }
  return ele;
}

function handleScrollContainerTouchStart(evt, ele) {
  ele = getScrollElement(evt, ele);

  const touchEvt = getTouchEvent(evt);
  if (!touchEvt) {
    return;
  }

  ele.xmLastY = touchEvt.pageY;

  // WARNING: 可能导致内容闪烁
  adjustScrollIfReachEdge(ele);
}

function handleScrollContainerTouchMove(evt, ele) {
  ele = getScrollElement(evt, ele);
  const touchEvt = getTouchEvent(evt);
  if (!touchEvt) {
    return;
  }

  const tryScrollUp = touchEvt.pageY > ele.xmLastY;
  const tryScrollDown = touchEvt.pageY < ele.xmLastY;

  ele.xmLastY = touchEvt.pageY;

  if (
    (tryScrollUp && ele.xmCanScrollUp) ||
    (tryScrollDown && ele.xmCanScrollDown)
  ) {
    // 停止冒泡到document，避免触发preventDefault，以便支持内容滚动
    evt.stopPropagation();
  } else {
    // 触发preventDefault 禁止滚动
    // 建议使用css方式禁止touch滚动: touch-action: none;
    // 不要preventDefault, 否则内部容器无法滚动了
    // evt.preventDefault();
  }
}

function handleScrollContainerTouchEnd(evt, ele) {
  // eslint-disable-next-line
  ele = getScrollElement(evt, ele);
  setTimeout(() => {
    // WARNING: 可能导致内容闪烁
    adjustScrollIfReachEdge(ele);
  }, 1000);
}

function enableScrollFix() {
  // document.documentElement.style.
  // document.documentElement.style.touchAction='none'
  // document.body.style.touchAction='none'

  // 阻止document的touchmove事件的默认行为
  // document.body.addEventListener("touchmove", handleDocumentTouchMove);

  documentDelegate.on(
    "touchstart",
    SCROLL_CONTAINER_SELECTOR,
    handleScrollContainerTouchStart
  );
  // 给某个div设置.scrollable样式，激活其touchmove事件（停止冒泡到document）
  documentDelegate.on(
    "touchmove",
    SCROLL_CONTAINER_SELECTOR,
    handleScrollContainerTouchMove
  );
  documentDelegate.on(
    "touchend",
    SCROLL_CONTAINER_SELECTOR,
    handleScrollContainerTouchEnd
  );
}

function disableScrollFix() {
  // documentDelegate.off("touchmove", handleDocumentTouchMove);
  documentDelegate.off(
    "touchstart",
    SCROLL_CONTAINER_SELECTOR,
    handleScrollContainerTouchStart
  );
  documentDelegate.off(
    "touchmove",
    SCROLL_CONTAINER_SELECTOR,
    handleScrollContainerTouchMove
  );
  documentDelegate.off(
    "touchend",
    SCROLL_CONTAINER_SELECTOR,
    handleScrollContainerTouchEnd
  );
}

export { enableScrollFix, disableScrollFix };



// WEBPACK FOOTER //
// ./src/utils/scrollFix.js